import React from 'react';

import './typography.scss';

/**
 * General Typography component, use for anything that involves *user interaction*
 */
const MainTitle = ({ children }) => (
	<div className="main-title">
		<h2>{children}</h2>
	</div>
);

const SecondaryTitle = ({ children }) => (
	<div className="secondary-title">
		<h3>{children}</h3>
	</div>
);

export { MainTitle, SecondaryTitle };
